var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useGoogleOneTapLogin } from '../GoogleOneTapLogin';
import { Brand, LalaSentry, getBrandFromHostname, getEnv } from '@lendi/lala-utils';
import { useSession } from '../useSession';
import { authenticateByAuth0 } from './authenticateByAuth0';
export function useGoogleOTIntegration(_a) {
    var _b, _c;
    var enabled = _a.enabled, googleOAuthClientId = _a.googleOAuthClientId, additionalGoogleOAuthConfigs = _a.additionalGoogleOAuthConfigs, env = _a.env, events = _a.events;
    var session = useSession();
    var brand = getBrandFromHostname();
    LalaSentry.logInfo('useGoogleOTIntegration called', {
        enabled: enabled,
        brand: brand,
        googleOAuthClientIdL: googleOAuthClientId === null || googleOAuthClientId === void 0 ? void 0 : googleOAuthClientId.length,
    });
    var environment = getEnv(env);
    var _d = additionalGoogleOAuthConfigs !== null && additionalGoogleOAuthConfigs !== void 0 ? additionalGoogleOAuthConfigs : {}, prompt_parent_id = _d.prompt_parent_id, cancel_on_tap_outside = _d.cancel_on_tap_outside, auto_select = _d.auto_select, itp_support = _d.itp_support, context = _d.context, nonce = _d.nonce, state_cookie_domain = _d.state_cookie_domain;
    var googleAccountConfigs = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ client_id: googleOAuthClientId }, (prompt_parent_id !== undefined && { prompt_parent_id: prompt_parent_id })), (cancel_on_tap_outside !== undefined && { cancel_on_tap_outside: cancel_on_tap_outside })), (auto_select !== undefined && { auto_select: auto_select })), (itp_support !== undefined && { itp_support: itp_support })), (context !== undefined && { context: context })), (nonce !== undefined && { nonce: nonce })), (context !== undefined && { context: context })), (state_cookie_domain !== undefined && { state_cookie_domain: state_cookie_domain }));
    var disabled = ![Brand.Lendi, Brand.Aussie].includes(brand) || !enabled || !!((_b = session === null || session === void 0 ? void 0 : session.identity) === null || _b === void 0 ? void 0 : _b.id);
    LalaSentry.logInfo('Display Google One Tap', { disabled: disabled, environment: environment, userId: (_c = session === null || session === void 0 ? void 0 : session.identity) === null || _c === void 0 ? void 0 : _c.id });
    useGoogleOneTapLogin({
        disabled: disabled,
        onRender: function () { var _a; return (_a = events === null || events === void 0 ? void 0 : events.onRendered) === null || _a === void 0 ? void 0 : _a.call(events); },
        onError: function (error) { return LalaSentry.logError('Google One Tap failed', { error: error }); },
        onSuccess: function (_a) {
            var _b;
            var email = _a.email;
            (_b = events === null || events === void 0 ? void 0 : events.onSelected) === null || _b === void 0 ? void 0 : _b.call(events);
            authenticateByAuth0(session, environment, email).catch(function (error) {
                return LalaSentry.logError('Auth0 authN failed', { error: error });
            });
        },
        googleAccountConfigs: googleAccountConfigs,
    });
}
//# sourceMappingURL=useGoogleOTIntegration.js.map